<script setup lang="ts">
import MacOSUpdatesView from '@/components/admin/views/MacOSUpdatesView.vue'
</script>

<template>
  <MacOSUpdatesView />
</template>
